import type { ContentItem } from '@hub/models/data';

export enum FilterType {
  RANGE = 'RANGE',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  CHECKBOX = 'CHECKBOX',
  NUMBER = 'NUMBER',
}

export type Type = FilterType.RANGE | FilterType.AUTOCOMPLETE | FilterType.CHECKBOX | FilterType.NUMBER;

export interface CheckboxFilter {
  key: string;
  id: string;
  label: string;
  disabled: boolean;
  value: boolean;
  onChange: (values: boolean) => void;
}

export type ReturnValueForT<T extends FilterType> = T extends FilterType.CHECKBOX
  ? boolean | undefined
  : T extends FilterType.NUMBER
    ? number | undefined
    : T extends FilterType.RANGE
      ? number | undefined
      : T extends FilterType.AUTOCOMPLETE
        ? string[] | undefined
        : never;

export const freeFormHubFilterKeys = {
  MATERIAL: 'material',
  PRODUCTION_METHOD: 'productionMethod',
  TEMPERATURE_RANGE_MIN: 'minTemperature',
  TEMPERATURE_RANGE_MAX: 'maxTemperature',
  FDA_COMPLIANCE: 'foodContactFDACompliant',
  EU102011_COMPLIANCE: 'foodContactEUCompliant',
  DIRT_AND_DUST: 'dirtResistant',
  LOW_WATER_ABSORBTION: 'lowWaterAbsorption',
  CHEMICALS: 'highChemicalResistance',
  UNDERWATER_SPLASHWATER: 'underWaterCompliant',
  ELECTRICALLY_CONDUCTIVE: 'electricallyConductive',
  MAX_SURFACE_PRESSURE: 'maxSurfacePressure',
  DIMENSIONS: 'dimensions',
  QUANTITY: 'quantity',
  PTFE_FREE: 'PTFEFree',
  PFAS_FREE: 'PFASFree',
  US_ONLY_MATERIALS: 'usOnlyMaterials',
} as const;

export type FreeFormHubFilterKeysType = (typeof freeFormHubFilterKeys)[keyof typeof freeFormHubFilterKeys];

export type freeFormFilterValues = {
  [key in FreeFormHubFilterKeysType]?: string;
};

export type FilterValueUrlParser<FilterT extends FilterType> = (urlValue: string) => ReturnValueForT<FilterT>;

export interface ContentItemWithId extends ContentItem {
  id: string;
}
